"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedNumber = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var numberjs_1 = require("@gooddata/numberjs");
var DEFAULT_FORMAT = "#,#.##";
/**
 * @internal
 */
exports.FormattedNumber = function (_a) {
    var className = _a.className, value = _a.value, _b = _a.format, format = _b === void 0 ? DEFAULT_FORMAT : _b, separators = _a.separators;
    var formattedNumber = numberjs_1.numberFormat(value, format, undefined, separators);
    var _c = numberjs_1.colors2Object(formattedNumber), label = _c.label, color = _c.color, backgroundColor = _c.backgroundColor;
    return (react_1.default.createElement("span", { className: className, style: { color: color, backgroundColor: backgroundColor } }, label));
};
//# sourceMappingURL=FormattedNumber.js.map